import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);
// 修复：避免未捕获的 router.push/replace promise 导致控制台报错（NavigationDuplicated / Redirected 等）
{
  const originalPush = VueRouter.prototype.push;
  VueRouter.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject);
    return originalPush.call(this, location).catch(err => err);
  };
  const originalReplace = VueRouter.prototype.replace;
  VueRouter.prototype.replace = function replace(location, onResolve, onReject) {
    if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject);
    return originalReplace.call(this, location).catch(err => err);
  };
}
import { Toast } from "vant";
import authService from "@/utils/authService";
import store from "@/store";
import supplier from "./supplier"; //供应商相关
import operate from "./operate"; //运营端相关
import client from "./client"; //客户相关
import shareOff from "./shareOff"; //推荐官相关
import warehouse from "./warehouse"; //运营端---仓库相关
import financial from "./financial"; //运营端---财务审核相关
import expertEnd from "./expertEnd"; //达人端相关
import replenishmentClient from "./replenishmentClient"; //配货端客户相关
import smallShop from "./smallShop"; //小店相关
import exhibition from "./exhibition"; //展会相关
const router = new VueRouter({
  mode: "hash",
  routes: [
    {
      path: "/",
      redirect: () => {
        // 检查是否已经免登成功
        if (authService.isAutoLoginEnabled() && authService.isAuthenticated()) {
          // 根据用户类型重定向到对应页面
          const userInfo = authService.getUserInfo();
          if (userInfo && userInfo.accountType === 6) {
            return { path: "/replenishment" };
          }
        }
        // 默认跳转到登录页面
        return { path: "/login", query: { type: 6 } };
      },
    },
    {
      path: "/choice", //登录注册起始页
      name: "Choice",
      meta: {
        navBarFlag: false,
        tabBarFlag: false,
        requiredAuth: false,
      },
      component: () => import("@pages/choice"),
    },
    {
      path: "/paginationTest", //分页测试页面
      name: "PaginationTest",
      meta: {
        navBarFlag: false,
        tabBarFlag: false,
        requiredAuth: false,
      },
      component: () => import("@pages/paginationTest"),
    },
    {
      path: "/register", //注册
      name: "Register",
      meta: {
        navBarFlag: true,
        tabBarFlag: false,
        requiredAuth: false,
      },
      component: () => import("@pages/register"),
    },
    {
      path: "/login", //密码登录
      name: "Login",
      meta: {
        navBarFlag: false,
        tabBarFlag: false,
        requiredAuth: false,
      },
      component: () => import("@pages/login"),
    },
    {
      path: "/verifyLogin", //验证码登录
      name: "VerifyLogin",
      meta: {
        navBarFlag: true,
        tabBarFlag: false,
        requiredAuth: false,
      },
      component: () => import("@pages/login/verifyLogin"),
    },
    {
      path: "/verify", //验证码
      name: "Verify",
      meta: {
        navBarFlag: true,
        tabBarFlag: false,
        requiredAuth: false,
      },
      component: () => import("@pages/verify"),
    },
    {
      path: "/setPwd", //初次设置密码
      name: "SetPwd",
      meta: {
        navBarFlag: true,
        tabBarFlag: false,
        requiredAuth: false,
      },
      component: () => import("@pages/passWord/setPwd"),
    },
    {
      path: "/resetPwd", //重置密码
      name: "ResetPwd",
      meta: {
        navBarFlag: true,
        tabBarFlag: false,
        requiredAuth: false,
      },
      component: () => import("@pages/passWord/resetPwd"),
    },
    {
      path: "/search", //搜索过渡页
      name: "Search",
      meta: {
        navBarFlag: false,
        tabBarFlag: true,
        requiredAuth: false,
      },
      component: () => import("@pages/search"),
    },
    {
      path: "/searchResult", //搜索结果页-供应商
      name: "SearchResult",
      meta: {
        navBarFlag: false,
        tabBarFlag: true,
        requiredAuth: false,
      },
      component: () => import("@pages/search/result.vue"),
    },
    {
      path: "/searchResultClient", //搜索结果页-客户
      name: "SearchResultClient",
      meta: {
        navBarFlag: false,
        tabBarFlag: true,
        requiredAuth: false,
      },
      component: () => import("@pages/search/resultClient.vue"),
    },

    //******判断当前角色进行跳转
    {
      path: "/initPage",
      name: "InitPage",
      component: () => import("@pages/index"),
    },

    {
      path: "/initPageSmallShop",//小店分享链接使用
      name: "InitPageSmallShop",
      component: () => import("@pages/initPage/initPageShare.vue"),
    },

    {
      path: "/initPageShareCouponList",//供优惠券分享链接使用
      name: "InitPageShareCouponList",
      component: () => import("@pages/initPage/initPageShare.vue"),
    },
    {
      path: "/InitPageShareSearch",//供搜索结果分享链接使用
      name: "InitPageShareSearch",
      component: () => import("@pages/initPage/initPageShare.vue"),
    },
    {
      path: "/initPageShareClassification",//供客户分类页分享链接使用
      name: "InitPageShareClassification",
      component: () => import("@pages/initPage/initPageShare.vue"),
    },
    {
      path: "/initPageShareComb",//供分享官组合分享分享链接使用
      name: "InitPageShareComb",
      component: () => import("@pages/initPage/initPageShare.vue"),
    },
    {
      path: "/initPageShareActivityList",//供分享活动分享链接使用
      name: "InitPageShareActivityList",
      component: () => import("@pages/initPage/initPageShare.vue"),
    },
    {
      path: "/initPageShareCombLook",//供分享官组合分享链接使用
      name: "InitPageShareCombLook",
      component: () => import("@pages/initPage/initPageShare.vue"),
    },
    {
      path: "/initPageShareCombVideoList",//供分享官视频组合分享链接使用
      name: "InitPageShareCombVideoList",
      component: () => import("@pages/initPage/initPageShare.vue"),
    },
    {
      path: "/initPageShareMarketDashboard",//供分享官分享行业看板使用
      name: "InitPageShareMarketDashboard",
      component: () => import("@pages/initPage/initPageShare.vue"),
    },
    {
      path: "/initPageShareRecommendsList",//供分享官分享推荐列表使用
      name: "InitPageShareRecommendsList",
      component: () => import("@pages/initPage/initPageShare.vue"),
    },
    {
      path: "/initPageShareStock",//供分享官分享现货库存使用
      name: "InitPageShareStock",
      component: () => import("@pages/initPage/initPageShare.vue"),
    },
    {
      path: "/initPageShareProduct",//供产品分享链接使用
      name: "initPageShareProduct",
      component: () => import("@pages/initPage/initPageShare.vue"),
    },
    {
      path: "/initPageShareMaterialVideo",//供视频素材分享链接使用
      name: "InitPageShareMaterialVideo",
      component: () => import("@pages/initPage/initPageShare.vue"),
    },
    {
      path: "/initPageShareMaterialImage",//供图片素材分享链接使用
      name: "InitPageShareMaterialImage",
      component: () => import("@pages/initPage/initPageShare.vue"),
    },
    {
      path: "/initPageShareLuckyDraw",//供抽奖活动分享链接使用
      name: "InitPageShareLuckyDraw",
      component: () => import("@pages/initPage/initPageShare.vue"),
    },
    {
      path: "/initPageReplenishment",//供配货平台分享链接使用（客户版）
      name: "InitPageReplenishment",
      component: () => import("@pages/initPage/initPageShare.vue"),
    },
    {
      path: "/initPageReplenishmentOrderDetail",//供报价单详情分享链接使用
      name: "InitPageReplenishmentOrderDetail",
      component: () => import("@pages/initPage/initPageShare.vue"),
    },
    {
      path: "/initPageDistributionSupplier",//供配货平台分享链接使用（商家版）
      name: "InitPageDistributionSupplier",
      component: () => import("@pages/initPage/initPageShare.vue"),
    },
    {
      path: "/initPageShareExhibition",//供展会首页分享链接使用
      name: "InitPageShareExhibition",
      component: () => import("@pages/initPage/initPageShare.vue"),
    },
    {
      path: "/initPageShareExhibitionProduct",//供展会商品详情分享链接使用
      name: "InitPageShareExhibitionProduct",
      component: () => import("@pages/initPage/initPageShare.vue"),
    },
    {
      path: "/initPageShareExhibitionShop",//供展会小店分享链接使用
      name: "InitPageShareExhibitionShop",
      component: () => import("@pages/initPage/initPageShare.vue"),
    },
    {
      path: "/initPageShareExhibitionSearch",//供展会搜索分享链接使用
      name: "InitPageShareExhibitionSearch",
      component: () => import("@pages/initPage/initPageShare.vue"),
    },
    {
      path: "/initPageShareSeckillRegister",//供秒杀注册分享链接使用
      name: "InitPageShareSeckillRegister",
      component: () => import("@pages/initPage/initPageShare.vue"),
    },
    ...supplier, //供应商相关
    ...operate, //运营端相关
    ...client, //客户相关
    ...shareOff,//推荐官相关
    ...warehouse, //仓库相关
    ...financial, //财务审核相关
    ...expertEnd, //达人端相关
    ...replenishmentClient, //配货端客户相关
    ...smallShop, //小店相关
    ...exhibition, //展会相关

    {
      path: "/home", //首页
      name: "home",
      meta: {
        tabBarFlag: true,
        requiredAuth: true,
        title: "首页 - 小炮庄",
      },
      component: () => import("@pages/home"),
    },
    {
      path: "/sort", //分类
      name: "sort",
      meta: {
        tabBarFlag: true,
        requiredAuth: true,
      },
      component: () => import("@pages/sort"),
    },
    {
      path: "/cart", //购物车
      name: "cart",
      meta: {
        tabBarFlag: true,
        requiredAuth: true,
      },
      component: () => import("@pages/cart"),
    },
    {
      path: "/viewPriSupp", //协议-商家
      name: "viewPriSupp",
      meta: {
        tabBarFlag: false,
        requiredAuth: false,
      },
      component: () => import("@pages/viewPrivice/supp.vue"),
    },
    {
      path: "/viewPriClient", //协议-客户
      name: "viewPriSupp",
      meta: {
        tabBarFlag: false,
        requiredAuth: false,
      },
      component: () => import("@pages/viewPrivice/client.vue"),
    },
    {
      path: "/viewPrivacy", //隐私政策
      name: "viewPrivacy",
      meta: {
        tabBarFlag: false,
        requiredAuth: false,
      },
      component: () => import("@pages/viewPrivice/privacy.vue"),
    },
    {
      path: "/privacy-ios",
      name: "PrivacyIOS",
      meta: {
        tabBarFlag: false,
        requiredAuth: false,
      },
      component: () => import("@pages/viewPrivice/privacy-ios.vue"),
    },
    {
      path: "/aboutUs", //关于我们
      name: "aboutUs",
      meta: {
        tabBarFlag: false,
        requiredAuth: false,
      },
      component: () => import("@pages/aboutUs/index.vue"),
    },
    {
      path: "/xpzHomePage", //首页
      name: "xpzHomePage",
      meta: {
        tabBarFlag: false,
        requiredAuth: false,
      },
      component: () => import("@pages/aboutUs/home.vue"),
    },
    {
      path: "/maVideoView", //视频播放
      name: "MaVideoView",
      meta: {
        tabBarFlag: false,
        requiredAuth: false,
      },
      component: () => import("@pages/maVideoView/index.vue"),
    },
    {
      path: "/titleDemo", //标题管理演示
      name: "TitleDemo",
      meta: {
        tabBarFlag: false,
        requiredAuth: false,
        title: "标题管理演示 - 小炮庄",
      },
      component: () => import("@pages/titleDemo/index.vue"),
    },
    {
      path: "/apiTest", //API接口测试
      name: "ApiTest",
      meta: {
        tabBarFlag: false,
        requiredAuth: false,
        title: "API测试 - 小炮庄",
      },
      component: () => import("@pages/apiTest/index.vue"),
    },
    {
      path: "/materialTest", //素材接口测试
      name: "MaterialTest",
      meta: {
        tabBarFlag: false,
        requiredAuth: false,
        title: "素材测试 - 小炮庄",
      },
      component: () => import("@pages/materialTest/index.vue"),
    },
    {
      path: "/luckyDraw", //抽奖活动页面
      name: "LuckyDraw",
      meta: {
        tabBarFlag: false,
        requiredAuth: false,
        title: "小炮庄惊喜抽奖",
      },
      component: () => import("@pages/luckyDraw/index.vue"),
    },
    // {
    //   path: "/productDetail", //商品详情（示例）
    //   name: "ProductDetail",
    //   meta: {
    //     tabBarFlag: false,
    //     requiredAuth: false,
    //     title: "商品详情 - 小炮庄", // 默认标题，会被组件内的动态标题覆盖
    //   },
    //   component: () => import("@pages/productDetail/index.vue"),
    // },
  ],
});

router.beforeEach((to, from, next) => {
  // 不在这里设置默认标题，让各页面自己设置动态标题
  // 只有当路由元信息中有自定义标题时才设置
  // if (to.meta && to.meta.title) {
  //   document.title = to.meta.title;
  // } else {
  //   document.title = "小炮庄"; // 默认title
  // }

  // 记录来源页面路径
  const fromPath = from.path;
  // 存储到sessionStorage
  sessionStorage.setItem('backPathXpz', JSON.stringify(fromPath));
  // 使用 Vue.set 设置到路由元信息
  Vue.set(to.meta, 'from', fromPath);

  // 打印调试信息
  console.log('路由切换:', {
    from: fromPath,
    to: to.path,
    referrer: document.referrer
  });

  // 兜底：verifyLogin 未携带 type 时，自动补齐
  if (to.path === "/verifyLogin" && (to.query.type === undefined || to.query.type === null || to.query.type === "")) {
    let typeFallback = null;
    // 1) 优先 sessionStorage
    const ssType = sessionStorage.getItem("accountTypeXpz");
    if (ssType) {
      try { typeFallback = JSON.parse(ssType); } catch(e) { console.warn("parse sessionStorage.accountTypeXpz error:", e); }
    }
    // 2) 再看 userInfoXpz
    if (typeFallback === null || typeFallback === undefined) {
      const ssUser = sessionStorage.getItem("userInfoXpz");
      if (ssUser) {
        try { typeFallback = JSON.parse(ssUser)?.accountType; } catch(e) { console.warn("parse sessionStorage.userInfoXpz error:", e); }
      }
    }
    // 3) 再看 localStorage
    if (typeFallback === null || typeFallback === undefined) {
      const lsType = localStorage.getItem("accountTypeXpz");
      if (lsType) {
        try { typeFallback = JSON.parse(lsType); } catch(e) { console.warn("parse localStorage.accountTypeXpz error:", e); }
      }
    }
    if (typeFallback !== null && typeFallback !== undefined) {
      // 保留已有 query，补齐 type
      next({ path: to.path, query: { ...to.query, type: typeFallback } });
      return;
    }
  }

  // if(to.path!="/choice" || to.path!="/login" || to.path!="/register"){
  //      // 定义正则表达式
  //     const regex = /\?.+?(?=#)/g;
  //     window.location.href=window.location.href.replace(regex, '')
  // }
   
  // if(to.path == "/productDetail"){
  //   next()
  //   return;
  // }
  if (to.path != "/login"  &&to.path != "/verifyLogin"  && to.meta.requiredAuth) {
    // 根据平台使用不同的认证检查方式
    if (authService.isAutoLoginEnabled()) {
      // 原生App：使用新的认证服务检查认证状态
      if (authService.isAuthenticated()) {
        next();
      } else {
        // 检查是否正在刷新token，如果是则等待
        if (store.getters.isRefreshingToken) {
          // 等待token刷新完成后再检查
          const checkAuth = () => {
            if (!store.getters.isRefreshingToken) {
              if (authService.isAuthenticated()) {
                next();
              } else {
                redirectToLogin();
              }
            } else {
              setTimeout(checkAuth, 100);
            }
          };
          checkAuth();
        } else {
          redirectToLogin();
        }
      }
    } else {
      // 浏览器/H5：使用传统的sessionStorage检查
      if (
        JSON.parse(sessionStorage.getItem("userInfoXpz")) &&
        JSON.parse(sessionStorage.getItem("userInfoXpz")).access_token
      ) {
        next();
      } else {
        Toast("请重新登录后操作!");
        if (
          JSON.parse(sessionStorage.getItem("userInfoXpz")) &&
          JSON.parse(sessionStorage.getItem("userInfoXpz")).accountType
        ) {
          let accountType = JSON.parse(
            sessionStorage.getItem("userInfoXpz")
          ).accountType;
          next({ path: "/verifyLogin", query: { type: accountType, ...to.query } });
        } else {
          if (to.path == "/productDetail") {
            // 获取当前页面的完整 URL
            const currentURL = window.location.href;

            // 使用正则表达式匹配 URL 中的查询参数部分
            const parameterMatch = currentURL.match(/\?(.*)/);

            if (parameterMatch) {
              // 如果有匹配到参数部分
              const queryString = parameterMatch[1];

              // 将查询参数字符串解析为对象
              const params = {};
              queryString.split("&").forEach((pair) => {
                const [key, value] = pair.split("=");
                params[key] = decodeURIComponent(value);
              });
              console.log(params,'paramsparams')
              // 使用 params 获取特定参数的值
              const parameterValueId = params.id;
              const parameterValueAccountId = params.accountId;
              if(parameterValueId && parameterValueAccountId){
                next({ path: "/verifyLogin", query: { xpzShareProductId: parameterValueId,xpzShareAccountId:parameterValueAccountId,type:1 } });
              }
            }
          } else {
            next({ path: "/verifyLogin", query: to.query });
          }
        }
      }
    }
    const redirectToLogin = () => {
      Toast("请重新登录后操作!");

      // 尝试从sessionStorage获取账号类型（向后兼容）
      let accountType = null;
      try {
        const userInfoStr = sessionStorage.getItem("userInfoXpz");
        if (userInfoStr) {
          const userInfo = JSON.parse(userInfoStr);
          accountType = userInfo.accountType;
        }
      } catch (e) {
        console.warn("从sessionStorage获取账号类型失败:", e);
      }

      // 如果还没有账号类型，尝试从localStorage获取
      if (!accountType) {
        try {
          const accountTypeStr = localStorage.getItem("accountTypeXpz");
          if (accountTypeStr) {
            accountType = JSON.parse(accountTypeStr);
          }
        } catch (e) {
          console.warn("从localStorage获取账号类型失败:", e);
        }
      }

      if (accountType) {
        next({ path: "/verifyLogin", query: { type: accountType, ...to.query } });
      } else {
        if (to.path == "/productDetail") {
          // 获取当前页面的完整 URL
          const currentURL = window.location.href;

          // 使用正则表达式匹配 URL 中的查询参数部分
          const parameterMatch = currentURL.match(/\?(.*)/);

          if (parameterMatch) {
            // 如果有匹配到参数部分
            const queryString = parameterMatch[1];

            // 将查询参数字符串解析为对象
            const params = {};
            queryString.split("&").forEach((pair) => {
              const [key, value] = pair.split("=");
              params[key] = decodeURIComponent(value);
            });
            console.log(params,'paramsparams')
            // 使用 params 获取特定参数的值
            const parameterValueId = params.id;
            const parameterValueAccountId = params.accountId;
            if(parameterValueId && parameterValueAccountId){
              next({ path: "/verifyLogin", query: { xpzShareProductId: parameterValueId,xpzShareAccountId:parameterValueAccountId,type:1 } });
            }
          }
        } else {
          next({ path: "/verifyLogin", query: to.query });
        }
      }
    }
  } else {
    next();
  }
});

export default router;
